import { motion } from "framer-motion";
import { DraftingCompass, FlaskConical, HardHat, Building2, Route, Landmark, Building } from "lucide-react";

const industries = [
  { icon: DraftingCompass, name: "Engineering Firms", desc: "Geotechnical, civil, and structural engineers" },
  { icon: FlaskConical, name: "Testing Laboratories", desc: "Construction materials and environmental labs" },
  { icon: HardHat, name: "General Contractors", desc: "Site work, vertical, and heavy civil GCs" },
  { icon: Building2, name: "Developers", desc: "Commercial, industrial, and residential" },
  { icon: Route, name: "Roadway Contractors", desc: "Paving, milling, and DOT contractors" },
  { icon: Building, name: "Commercial Construction", desc: "Buildings, facilities, and infrastructure" },
  { icon: Landmark, name: "Government Agencies", desc: "Municipalities, counties, and public works" },
];

export default function Industries() {
  return (
    <section id="industries" className="py-24 lg:py-32 bg-white" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A00] mb-4 font-mono-tech" data-testid="industries-overline">
            Industries Served • 04
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-[#0F172A]" data-testid="industries-heading">
            Who We Work With
          </h2>
          <p className="mt-6 text-base text-slate-600 leading-relaxed">
            We support the teams that design, build, and maintain Greater Houston's infrastructure.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5 }}
          className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-slate-200"
          data-testid="industries-grid"
        >
          {industries.map((ind, i) => (
            <div
              key={ind.name}
              className="group border-r border-b border-slate-200 p-8 hover:bg-[#0F172A] transition-colors duration-200"
              data-testid={`industry-cell-${i}`}
            >
              <ind.icon className="w-8 h-8 text-[#FF5A00]" />
              <h3 className="mt-5 font-heading text-lg font-bold uppercase tracking-tight text-[#0F172A] group-hover:text-white transition-colors duration-200">
                {ind.name}
              </h3>
              <p className="mt-2 text-sm text-slate-600 group-hover:text-slate-300 transition-colors duration-200">
                {ind.desc}
              </p>
            </div>
          ))}
          <a
            href="#quote"
            className="group border-r border-b border-slate-200 p-8 bg-[#FF5A00] hover:bg-[#E04F00] transition-colors duration-200 flex flex-col justify-between"
            data-testid="industry-cta-cell"
          >
            <h3 className="font-heading text-lg font-bold uppercase tracking-tight text-white">
              Your project here
            </h3>
            <p className="mt-4 text-sm font-semibold uppercase tracking-wider text-white/90 underline underline-offset-4">
              Start a quote →
            </p>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
